import { storageService } from 'js/services/storage.service';

import { INFO_GAME_FEED_FROM_STORAGE, INFO_GAME_LIST_FROM_STORAGE } from './constants';

export const getGameListFromStorage = () => storageService.session.getItem(INFO_GAME_LIST_FROM_STORAGE) || [];
export const getGameFeedFromStorage = () => storageService.session.getItem(INFO_GAME_FEED_FROM_STORAGE) || '';

export const setGameListInStorage = (infoGameList) => storageService.session.setItem(INFO_GAME_LIST_FROM_STORAGE, infoGameList);
export const setGameFeedInStorage = (infoGameList) => storageService.session.setItem(INFO_GAME_FEED_FROM_STORAGE, infoGameList);

export const removeGameListFromStorage = () => storageService.session.removeItem(INFO_GAME_LIST_FROM_STORAGE);
export const removeGameFeedFromStorage = () => storageService.session.removeItem(INFO_GAME_FEED_FROM_STORAGE);
